module.exports = __webpack_public_path__ + "img/ProtocolIcon.80da36f4.svg";